import { useEffect, useRef } from "react";
import peopleGroup from "../assets/careers-people-grouped.png";
import lamp from "../assets/lamp.png";
import windowLeft from "../assets/window-left.png";
import windowRight from "../assets/window-right.png";
import clock from "../assets/clock.png";
import { FiSearch, FiBriefcase, FiStar, FiArrowRight } from "react-icons/fi";

export default function CareersSection() {
    const jobList = [
  {
    title: "Product Marketers",
    description: "We are looking for a dynamic and motivated Sales and Marketing Executive to join our ...",
  },
  {
    title: "Sales and Marketing Associate",
    description: "We are looking for a dynamic and motivated Sales and Marketing Executive to join our ...",
  },
  {
    title: "Digital Marketing Analyst",
    description: "We are looking for a dynamic and motivated Sales and Marketing Executive to join our ...",
  },
  {
    title: "UI/UX Designer",
    description: "We are looking for a creative UI/UX designer to improve user experience...",
  },
  {
    title: "Graphic Designer",
    description: "Join our creative team to build stunning visuals for clients across industries...",
  },
  {
    title: "Content Writer",
    description: "Craft compelling copy for websites, blogs, and marketing campaigns...",
  },
  {
    title: "SEO Specialist",
    description: "Improve search engine rankings and grow organic traffic...",
  },
  {
    title: "Social Media Manager",
    description: "Manage and grow our online community through social media strategies...",
  },
  {
    title: "Frontend Developer",
    description: "We are looking for a React developer to help build beautiful web interfaces...",
  },
];
  const lampRef = useRef(null);

  useEffect(() => {
    const flicker = setInterval(() => {
      if (lampRef.current) {
        lampRef.current.classList.toggle("opacity-30");
      }
    }, 700);
    return () => clearInterval(flicker);
  }, []);

  return (
    <>
    <section className="w-full bg-[#F7F8FA] font-poppins px-4 md:px-10 py-20 overflow-hidden relative">
      <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-start justify-between relative z-10 gap-10">
        {/* Left Side */}
        <div className="w-full lg:w-[62%] relative">
          {/* Title & Description */}
          <h2 className="text-[40px] md:text-[48px] font-semibold text-[#1E1E1E] leading-tight mb-4">
            We're a community united by <br /> shared values & purpose.
          </h2>
          <p className="text-[#4B5563] text-[18px] leading-[30px] mb-10 max-w-[600px]">
            Building a meaningful career is a journey — our goal is to make it seamless by offering
            a rewarding and inspiring work environment.
          </p>

          {/* Grouped People Image */}
          <div className="relative">
            <img
              src={peopleGroup}
              alt="People Group"
              className="w-full max-w-[700px] mt-12 relative z-10"
            />
            {/* Bottom shadow/line below image */}
            <div className="absolute bottom-[-8px] left-0 w-full h-[3px] bg-[black] opacity-60 rounded-full" />
          </div>

          {/* Windows */}
          <img
            src={windowLeft}
            alt="Window Left"
            className="absolute top-[22px] left-[-10px] w-[132px] h-[162px]"
          />
          <img
            src={windowRight}
            alt="Window Right"
            className="absolute top-[22px] left-[730px] w-[92px] h-[112px]"
          />

          {/* Lamp with Flicker */}
          <img
            ref={lampRef}
            src={lamp}
            alt="Lamp"
            className="absolute top-[168px] left-[120px] w-[170px] transition-opacity duration-300 ease-in-out"
          />

          {/* Clock with Spin */}
          <img
            src={clock}
            alt="Clock"
            className="absolute top-[135px] left-[620px] w-[48px] h-[48px] animate-spin-slow"
          />
        </div>

        {/* Right: Job Roles */}
        <div className="w-full lg:w-[36%] bg-white rounded-[16px] shadow-md px-6 py-8 z-10">
          <h4 className="text-[#4B5563] text-[14px] font-medium uppercase mb-6">
            High Demand Roles
          </h4>

          {[
            { title: "Sales and Marketing Associate", link: "/careers/sales-marketing" },
            { title: "Designers- UI/UX & Visual / Graphic", link: "/careers/designers" },
            { title: "Product Marketers", link: "/careers/product-marketers" },
            { title: "Digital Marketing Analyst", link: "/careers/digital-marketing" },
          ].map((role) => (
            <button
              key={role.title}
              onClick={() => (window.location.href = role.link)}
              className="w-full text-left border-b border-gray-200 py-4 flex items-center justify-between group"
            >
              <div>
                <h5 className="text-[#059669] font-semibold text-[16px] group-hover:underline">
                  {role.title}
                </h5>
                <p className="text-[#6B7280] text-[14px]">Full time | 0–3 years experience</p>
              </div>
              <span className="text-[20px] text-[#9CA3AF]">›</span>
            </button>
          ))}

          <button className="w-full mt-6 bg-[#F3F4F6] text-[#1F2937] text-[14px] font-semibold py-3 rounded-full hover:bg-gray-200">
            VIEW ALL →
          </button>
        </div>
      </div>
    </section>
    <section className="w-full font-poppins px-4 md:px-10 py-20 bg-white">
      {/* Heading */}
      <h2 className="text-center text-[36px] md:text-[40px] font-semibold text-[#1E1E1E] mb-10">
        Opportunities to grow your career
      </h2>

      {/* Search Bar */}
      <div className="max-w-[800px] mx-auto mb-12 relative">
        <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl" />
        <input
          type="text"
          placeholder="Search keywords..."
          className="w-full pl-12 pr-4 py-4 rounded-full border border-gray-200 shadow-sm text-[16px] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      {/* Grid of Job Cards */}
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {jobList.map((job, index) => (
          <div
            key={index}
            className="bg-white border border-gray-200 rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow duration-300 flex flex-col justify-between"
          >
            <div>
              <h3 className="text-[18px] font-semibold text-green-600 mb-2">{job.title}</h3>
              <p className="text-gray-500 text-[14px] leading-[22px] mb-4">{job.description}</p>

              {/* Details */}
              <div className="flex flex-col gap-2 text-[14px] text-[#111827] mb-6">
                <div className="flex items-center gap-2">
                  <FiBriefcase className="text-[16px]" />
                  <span>Full time</span>
                </div>
                <div className="flex items-center gap-2">
                  <FiStar className="text-[16px]" />
                  <span>0–3 years experience</span>
                </div>
              </div>
            </div>

            {/* Footer Button */}
            <button className="flex items-center justify-between bg-[#F3F4F6] text-[#111827] text-[14px] font-semibold px-5 py-3 rounded-full hover:bg-gray-200 transition">
              View job details <FiArrowRight className="ml-2 text-[16px]" />
            </button>
          </div>
        ))}
      </div>
    </section>
    </>
  );
}
